import { Pipe, PipeTransform } from '@angular/core';
import { RoleTypesEnum } from '@core/enums/role-types.enum';
import { UsersService } from '@services/users.service';
import { MenuItemModel, UserModel } from '../models';

@Pipe({
  name: 'filterByRole'
})
export class FilterByRolePipe implements PipeTransform {

  readonly userObject: UserModel;
  constructor(private readonly usersService: UsersService) {
    this.userObject = this.usersService.userValue;
  }

  transform(value: MenuItemModel[], opts?: any): MenuItemModel[] {

    // herhangi bir değer yoksa işlemi durduruyoruz.
    if (!value) {
      return;
    }

    return value.filter((menu: MenuItemModel) => {

      // sol menüde gösterilmesini istemediğimiz menüleri engelliyoruz.
      if (opts?.menuType === 'aside' && menu.isHideAside) {
        return;
      }

      // kullanıcın lisans tipine bakıyoruz, lisans tipine göre filtreliyoruz yalnız sistem admini dışında.
      if (menu.licenceType && !menu.licenceType.includes(this.userObject.LicenseType) && this.userObject.RoleType !== RoleTypesEnum.SystemAdmin) {
        return;
      }

      // spesifik roler için geçerli | Eğer develoepr menüsü sadece Developer yetkisi olan için gösterilmeisni istiyorsak bu alanı aktif ediyoruz.
      if (menu.specificRole === 'Developer' && !this.userObject.IsDeveloper) {
        return;
      }

      // ana menüleri filtreliyoruz.
      if (menu.role && !menu.role.includes(this.userObject.RoleType)) {
        return;
      }

      // alt menüleri filtreliyoruz
      if (menu.child) {
        menu.child = menu.child.filter((child: MenuItemModel) => {
          return (child.role && !child.role.includes(this.userObject.RoleType)) ? null : child;
        });
      }

      return menu;
    });
  }
}
